import { mergeStyles, Pivot, PivotItem } from "@fluentui/react";
import customTheme from "helpers/customTheme";
import { IPolicyInfo } from "./types";
import PolicyEditStructure from "./structure/PolicyEditStructure";
import PolicyEditProperties from "./properties/PolicyEditProperties";

const STRUCTURE_PIVOT_NAME = "Structure";
const PROPERTIES_PIVOT_NAME = "Properties";

const layerClass = mergeStyles({
  height: "calc(100vh - 98px)",
  overflow: "hidden",
  padding: "30px 40px",
  backgroundColor: customTheme.gridPaneBackgroundColor,
});

function PolicyEditPivot({ policyInfo }: { policyInfo: IPolicyInfo }) {
  return (
    <div className={layerClass}>
      <Pivot>
        <PivotItem headerText={STRUCTURE_PIVOT_NAME}>
          <PolicyEditStructure />
        </PivotItem>
        <PivotItem headerText={PROPERTIES_PIVOT_NAME}>
          <PolicyEditProperties policyInfo={policyInfo} />
        </PivotItem>
      </Pivot>
    </div>
  );
}

export default PolicyEditPivot;